<template>
  <div class="card is-min-width-500">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3">
            {{ $t('editBat.popUpUpload.title') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <error-msg-component :messages="messages"
                           :messagesChampsVide="messagesChampsVide"
                           :champsVide="champsVide"
                           :error="error"
                           :title="'general.problemOccurred'"
                           :withEmplyFields="true"
                           @close="error = $event"/>
      <div class="columns is-multiline">
        <b-field class="column is-6" :label="$t('editBat.popUpUpload.dateAccord')">
          <b-datepicker
            v-model="payload.dateAccord"
            icon="calendar-today"
            nearby-selectable-month-days
            show-week-number
            editable>
          </b-datepicker>
        </b-field>
        <div class="column is-6 mgt-35px">
          <b-checkbox v-model="payload.accordTelephonique">
            {{ $t('editBat.popUpUpload.accordTelephonique') }}
          </b-checkbox>
        </div>
        <b-field
          :label="$t('editBat.popUpUpload.commentaireAccord')"
          class="column is-12">
          <b-input
            v-model.number="payload.commentaireAccord"
            :use-html5-validation="false"
            type="textarea"
            rows="3"/>
        </b-field>
      </div>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="save()">
              {{ $t('general.button.sauvegarder') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>
import { updateLogistiquePresse } from '@/api/ligneCommande';
import messageErreur from '@/services/general/messageErreur';
import validationGeneral from '@/services/validation/validation';
import errorMsgComponent from '@/components/general/errorMsgComponent';

export default {
  components: { errorMsgComponent },
  props: {
    ligne: {
      type: Object,
      require: true,
    },
    etatBat: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      messages: [],
      error: false,
      champsVide: [],
      messagesChampsVide: [],
      payload: {
        accordTelephonique: false,
        commentaireAccord: '',
        dateAccord: new Date(),
      },
    };
  },
  methods: {
    async save() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await updateLogistiquePresse({
          ligneCommandeIds: [this.ligne.lignePresse.id],
          etatBat: this.etatBat,
          ...this.payload,
        });
        this.$emit('is-upload');
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data && e.response.data.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide);
          this.error = true;
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
};
</script>
